export const RECENTLY_VIEWED_POSITION = 19;
